import React from "react";

export const CustomDateInput = React.forwardRef(({ value, onClick }, ref) => (
    <input
      type="text"
      placeholder="Select Date"
      className="outline-none text-base bg-transparent border-1 mt-2 mb-2 p-3 w-hundred rounded-lg border-Bordergray"
      onClick={onClick}    
      readOnly             
      value={value}
      ref={ref}
    />
  ));